import Swiper, {
  // Navigation,
  // Pagination,
  Autoplay
} from 'swiper';

// import 'swiper/swiper.min.css';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

class InifiniteSlide {
  constructor(classes) {
    // this.el = el
    this.slides = document.querySelectorAll(classes)
    this.materDuration = 4000
    // this.mater  = document.getElementById('js-mater')
    this.swiper = this._init()
  }

  _init() {
    ;[].forEach.call(this.slides, slide => {
      const container = slide.querySelector('.swiper')
      // const prevEl = slide.querySelector('.c-swiper-btn_prev')
      // const nextEl = slide.querySelector('.c-swiper-btn_next')

      return new Swiper(container, {
        modules: [Autoplay],
        effect: 'slide',
        loop: true,
        slidesPerView: 3.4,
        speed: 9000,
        allowTouchMove: false, // スワイプ無効
        centeredSlides: true, // コンテンツ中央寄せ
        preventInteractionOnTransition: true,
        autoplay: {
          delay: 0, // 途切れなくループ
        },        
        breakpoints: {
          // 768px以上の場合
          768: {
            slidesPerView: 3.5,
          },
          // 1024px以上の場合
          1024: {
            slidesPerView: 3.5,
          },
          // 1501px以上の場合
          1501: {
            slidesPerView: 4.5,
          }
        }
      })
    })
  }

}

document.addEventListener('DOMContentLoaded', () => {
  new InifiniteSlide('.js-infinite-slide')
})
